module.exports = __webpack_public_path__ + "static/endsheet-b9e9dd1dd0e03c2870acab22cf2e9108.jpg";